import moment from 'moment';

import { isBeforeDay } from './isBeforeDay';
import { isSameDay } from './isSameDay';

export const isAfterDay = (a?: moment.Moment, b?: moment.Moment) => {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false;
  return !isBeforeDay(a, b) && !isSameDay(a, b);
};
